/** Build an absolute href from branding `about` (may be host-only). */
export const getBrandingAboutHref = (about?: string | null): string | null => {
  const value = String(about || "").trim();
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  return `https://${value}`;
};
